import React, { Component } from 'react';

import CanvasImageUpload from 'components/canvasEditor/image/CanvasImageUpload';
import { ENTITY_TYPE } from 'modules/file/constants';

import { UploadConsumer } from '@hotmart/club-files-ui';
@UploadConsumer(ENTITY_TYPE.CERTIFICATE_BACKGROUND_IMG)
export default class CanvasBackground extends Component {
  render() {
    return (
      <CanvasImageUpload
        {...this.props}
        className="text-menu__button--large"
        icon="image"
        toolTip="general.background_image"
        label="general.background_image"
      />
    );
  }
}
